import $ from 'jquery';
import blockUI from 'block-ui';

import { blockUISettings } from '../componentSettings/BlockUISettings.js';

import utils from './utils.js';

let inst;

class Language {
    constructor() {
        this.loadHandlers = [];
        if (!inst) {
            this.currentLanguage = null;
            this.languageConstants = {};
            this.isLoaded = false;
            inst = this;
        }
        return inst;
    }

    getCurrentLanguage() {
        if (!this.currentLanguage) {
            this.currentLanguage = $('html').attr('lang');
        }
        return this.currentLanguage;
    }

    loadLanguage(loadCallback) {
        utils.app_get(utils.getLocalizeUrl('/api/front/get-language-constants'), {}, {no_csrf_token: true}).then((resp) => {
            if (resp.type === 'success') {
                this.languageConstants = resp.message;
                this.isLoaded = true;

                $.blockUI.defaults.message = '<span class="icon-loading--small"></span> <span>' + this.getLabel('L_PROCESSING') + '</span>';
                $.blockUI.defaults.css = blockUISettings.css;
                $.blockUI.defaults.overlayCSS = blockUISettings.overlayCSS;

                this.loadHandlers.forEach((handler) => {
                    handler();
                });
                this.loadHandlers = [];
                if (typeof loadCallback === 'function') {
                    loadCallback();
                }
            }
        });
    }

    onLoad(handler) {
        if (this.isLoaded) {
            return handler();
        }
        this.loadHandlers.push(handler);
    }

    getLabel(constantName, param) {
        if (typeof param !== 'object') {
            param = {};
        }
        let phrase = '';
        if (this.languageConstants[constantName]) {
            phrase = this.bindParam(this.languageConstants[constantName], param)
        }
        return phrase;
    }

    bindParam(string, param) {
        for (let key in param) {
            if (param.hasOwnProperty(key)) {
                var reg = new RegExp(':' + key, 'g');
                string = string.replace(reg, param[key]);
            }
        }
        return string;
    }
}

export default new Language();